import declare from "dojo/_base/declare";
import StringRen from "csi/heading/String";
import ActualMixin from "./ActualMixin";

const ReviewActualComment = declare([StringRen, ActualMixin], {
    
	pushContext: function(/*Context*/ctx, /*Heading*/h) {
		// summary: matrix will already establish node context, so we can ignore path and continue
		ctx.pushParams();
		return true;
	},

	reserveContext: function(/*Context*/ctx, /*Heading*/h) {
		// summary: calculate keys into DimensionActualsComments stringmap
		var scd = ctx.getRowNode();
		ctx.keyValue = this._getDimensionActualsKey(ctx, scd);
		ctx.keyValue2 = this._getDimensionActualsKeyPre47(ctx, scd);
		ctx.keyOriginalValue = this._getDimensionOriginalKey(ctx, scd);
		ctx.keySuffix = this._getDimensionActualsKeySuffix(ctx, scd);   // To support unlinked/special SizeChartDimension
		this.inherited(arguments);
	},
});

export = ReviewActualComment;